import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BackButtonComponent } from './backButton';

@NgModule({
  imports: [
    ButtonModule
    , CommonModule
    , RouterModule
  ]
  , declarations: [
    BackButtonComponent
  ]
  , exports: [
    BackButtonComponent
  ]
})
export class CHAButtonsModule { }
